import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { ReactComponent as IconLT } from 'assets/flags/lt.svg';
import { ReactComponent as IconGB } from 'assets/flags/gb.svg';

import { LanguageIndicator_language$key } from '__generated__/LanguageIndicator_language.graphql';

const flags = {
  LT: <IconLT />,
  EN: <IconGB />,
};

type Props = {
  language: LanguageIndicator_language$key;
} & AvatarProps;

const LanguageIndicator: FC<Props> = ({ language, ...rest }) => {
  const { locale } = useFragment(
    graphql`
      fragment LanguageIndicator_language on Language {
        locale
      }
    `,
    language
  );

  return <Avatar {...rest}>{flags[locale]}</Avatar>;
};

export default LanguageIndicator;
